// ====== DISCUSSION EDIT HISTORY FEATURE START ======
import React, { useState, useEffect } from 'react';
import { Modal, Table, Spin, Empty } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import moment from 'moment';
import { GetDiscussionHistoryApi } from '../../api/plans/GetDiscussionHistoryApi';

const DiscussionHistoryModal = ({
  visible,
  onClose,
  discussionId,
}) => {
  const [loading, setLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    if (visible && discussionId) {
      fetchHistory();
    }
  }, [visible, discussionId]);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const response = await GetDiscussionHistoryApi(discussionId);
      
      if (response && response.success) {
        setHistoryData(response.data || []);
      } else {
        setHistoryData([]);
      }
    } catch (error) {
      console.error('Error fetching discussion history:', error);
      setHistoryData([]);
    }
    setLoading(false);
  };

  const columns = [
    {
      title: 'Date',
      dataIndex: 'editedOn',
      key: 'editedOn',
      width: 180,
      render: (date) => moment(date).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: 'Edited By',
      dataIndex: 'editorName',
      key: 'editorName',
      width: 150,
    },
    {
      title: 'Changes Made',
      key: 'changes',
      render: (_, record) => (
        <div>
          <div className="mb-2">
            <div className="text-xs text-gray-500 mb-1">Previous:</div>
            <div className="bg-red-50 p-2 rounded border border-red-200 text-sm">
              {record.previousMessage}
            </div>
          </div>
          <div>
            <div className="text-xs text-gray-500 mb-1">New:</div>
            <div className="bg-green-50 p-2 rounded border border-green-200 text-sm">
              {record.newMessage}
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <HistoryOutlined />
          <span>Message Edit History</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      bodyStyle={{ maxHeight: '70vh', overflow: 'auto' }}
    >
      {loading ? (
        <div className="flex justify-center items-center py-8">
          <Spin size="large" />
        </div>
      ) : historyData.length === 0 ? (
        <Empty description="No edit history found" />
      ) : (
        <Table
          columns={columns}
          dataSource={historyData}
          rowKey="id"
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
            showTotal: (total) => `Total ${total} edits`,
          }}
        />
      )}
    </Modal>
  );
};

export default DiscussionHistoryModal;
// ====== DISCUSSION EDIT HISTORY FEATURE END ======
